import { Flower2 } from "lucide-react";
import { MARQUEE_ITEMS } from "@/lib/data";

const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative bg-[#FAF8F5] border-y border-[#E2E8F0]/80 py-6 overflow-hidden marquee-mask">
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-['Outfit'] text-2xl sm:text-3xl font-light tracking-tight text-[#1A2E2A]/80 whitespace-nowrap">
              {item}
            </span>
            <Flower2 className="w-5 h-5 text-[#489A88] shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
